import { LightbulbFilament } from "@phosphor-icons/react";
import { Body } from "@hypercard/web-components";
import { IconBox } from "@common/components";

type SuggestionItemProps = {
  name: string;
  text: string;
  onClick: (text: string) => void;
};

const SuggestionItem = ({ name, text, onClick }: SuggestionItemProps) => (
  <button
    onClick={() => onClick(text)}
    className="rounded-sm bg-white/10 px-3 py-2 outline-none hover:bg-white/20"
  >
    <Body size="sm" weight="medium" className="text-white">
      {name}
    </Body>
  </button>
);

// @TODO: update suggestion text
const suggestions = [
  {
    name: "Receipt Required",
    text: "A receipt is required on all expenses submitted.",
  },
  {
    name: "Weekdays only",
    text: "Only applicable to expenses that are transacted on a weekday.",
  },
  {
    name: "Weekends only",
    text: "Only applicable to expenses that are transacted on Saturday or Sunday",
  },
  {
    name: "Restricted Merchants",
    text: "The following merchants are out of policy and should not be auto-approved:",
  },
  {
    name: "Economy Class Flights",
    text: "Flight expenses with a class higher than economy class should not be approved.",
  },
  {
    name: "Coffee under $10",
    text: "Employees are eligible to make coffee expenses under $10.",
  },
  {
    name: "Commute under $50",
    text: "Employees are eligible to take Lyft rides or take the subway as long as the expense is under $50.",
  },
  {
    name: "Hotel Accommodations",
    text: "Employees are expected to book mid-range accommodations. Any expenses for luxury accommodations require manual review.",
  },
  {
    name: "Fines and Penalties",
    text: "Fines and Penalties are always out of policy.",
  },
  {
    name: "Personal Expenses",
    text: "Personal expenses such as clothing, toiletries, etc. are always out of policy.",
  },
];
type SuggestionBoxProps = {
  appendText: (text: string) => void;
};
export const SuggestionBox = ({ appendText }: SuggestionBoxProps) => {
  return (
    <div className="flex w-full flex-wrap rounded-lg bg-[#292929] p-4">
      <div className="mb-6 flex items-center">
        <IconBox>
          <LightbulbFilament className="size-6 text-success" />
        </IconBox>
        <div className="ml-3 space-y-1">
          <Body size="sm" weight="medium">
            Hypercard suggestions
          </Body>
          <Body size="sm" weight="medium" className="text-white/50">
            Click any to automatically add it to your policy
          </Body>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {suggestions.map((suggestion) => (
          <SuggestionItem
            key={`suggestion-item--${suggestion.name}`}
            onClick={appendText}
            name={suggestion.name}
            text={suggestion.text}
          />
        ))}
      </div>
    </div>
  );
};
